import axios from "../network/reuset";
import qs from "qs";

const getMenu = {
  getMenuList(params) {
    return axios.post(`/api/admin/menu/list`, qs.stringify(params));
  },
  getAllMenuList(params) {
    return axios.post(`/api/admin/menu/all_list`, qs.stringify(params));
  },
  addMenu(params) {
    return axios.post(`/api/admin/menu/add`, qs.stringify(params));
  },
  saveMenu(params) {
    return axios.post(`/api/admin/menu/save_edit`, qs.stringify(params));
  },
  delMenuItem(params) {
    return axios.post(`/api/admin/menu/del`, qs.stringify(params));
  },
  getMenuItemInfo(params) {
    return axios.post(`/api/admin/menu/info`, qs.stringify(params));
  },
};

export default getMenu;
